document.getElementById('edit-profile-form').addEventListener('submit', async (e) => {
  e.preventDefault();
  const form = e.target;
  const formData = new FormData(form);
  const messageDiv = document.getElementById('form-message');
  const fileInput = document.getElementById('profile_picture');
  const file = fileInput.files[0];

  if (!file) {
    messageDiv.style.display = 'block';
    messageDiv.style.color = 'red';
    messageDiv.textContent = 'Por favor, selecione uma imagem.';
    return;
  }

  // Comprimir a imagem
  new Compressor(file, {
    quality: 0.6, // Qualidade da compressão (0 a 1)
    maxWidth: 800, // Redimensionar para largura máxima de 800px
    maxHeight: 800, // Redimensionar para altura máxima de 800px
    success(compressedFile) {
      formData.set('profile_picture', compressedFile, compressedFile.name);
      sendRequest(formData);
    },
    error(err) {
      console.error('Erro ao comprimir:', err);
      messageDiv.style.display = 'block';
      messageDiv.style.color = 'red';
      messageDiv.textContent = 'Erro ao comprimir a imagem: ' + err.message;
    }
  });

  async function sendRequest(formData) {
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData
      });
      if (!response.ok) {
        throw new Error('Erro na requisição: ' + response.statusText);
      }
      const result = await response.json();
      if (result.success) {
        messageDiv.style.display = 'block';
        messageDiv.style.color = 'green';
        messageDiv.textContent = result.message;
        setTimeout(() => location.reload(), 2000);
      } else {
        messageDiv.style.display = 'block';
        messageDiv.style.color = 'red';
        messageDiv.textContent = result.error;
      }
    } catch (error) {
      console.error('Erro no fetch:', error);
      messageDiv.style.display = 'block';
      messageDiv.style.color = 'red';
      messageDiv.textContent = 'Erro ao enviar o formulário: ' + error.message;
    }
  }
});